import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=85674708&scoped=true&lang=pug&"
var script = {}
import style0 from "./Loading.vue?vue&type=style&index=0&id=85674708&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85674708",
  null
  
)

component.options.__file = "Loading.vue"
export default component.exports